import {
  AbsenceEntry,
  AbsenceStatus,
  AbsenceType,
  LongAbsenceEntry,
  ShortAbsenceEntry,
} from '~/data/absences/types';
import {
  AbsenceStatusEnum,
  AbsenceTypeEnum,
  EmployeeProfileDto,
  IAbsenceDto,
} from '~/services/Http/client.people.generated';

export const transformAbsenceEntriesToAbsenceDto = (
  employeeId: number,
  absenceEntries: ShortAbsenceEntry[] | LongAbsenceEntry[],
  profile?: EmployeeProfileDto,
): IAbsenceDto[] => {
  if (!profile) return [];
  return absenceEntries.map((entry) => {
    return {
      id: entry.id ?? 0,
      uid: entry.uid ?? '',
      reason: {
        code: entry.reason.code,
        group:
          entry.type === 'SHORT'
            ? 'ABSENCE_SHORT_REASON'
            : 'ABSENCE_LONG_REASON',
        value: entry.reason.name,
        language: undefined,
      },
      status: {
        code: entry.status.toString() as AbsenceStatusEnum,
        group: 'ABSENCE_STATUS',
        language: undefined,
        value: entry.status,
      },
      type:
        entry.type === 'SHORT' ? AbsenceTypeEnum.SHORT : AbsenceTypeEnum.LONG,
      startDate: entry.startDate,
      endDate: entry.endDate,
      days: entry.type === 'SHORT' ? entry.days : undefined,
      employee: {
        firstName: profile.firstName,
        id: employeeId,
        lastName: profile.lastName,
        legalEntityId: profile.legalEntity,
        positionName: profile.positionName,
        profilePic: profile.profilePic,
        unit: profile.unit,
        userId: profile.userId,
        username: profile.username,
      },
    };
  });
};

export const resolveAbsenceDtoArraysFromAbsenceEntries = (
  selectedEmployeeId: number,
  absenceEntries: AbsenceEntry[],
  profile?: EmployeeProfileDto,
) => {
  const transformAbsenceEntries = (
    absenceEntries: ShortAbsenceEntry[] | LongAbsenceEntry[],
  ) =>
    transformAbsenceEntriesToAbsenceDto(
      selectedEmployeeId,
      absenceEntries,
      profile,
    );

  const calendarEntries = absenceEntries.filter(
    (a) => ![AbsenceStatus.REJECTED, AbsenceStatus.DRAFT].includes(a.status),
  );

  return {
    shortAbsences: transformAbsenceEntries(
      calendarEntries.filter(
        (a) => a.type === AbsenceType.SHORT,
      ) as ShortAbsenceEntry[],
    ),
    longAbsences: transformAbsenceEntries(
      calendarEntries.filter(
        (a) => a.type === AbsenceType.LONG,
      ) as LongAbsenceEntry[],
    ),
  };
};
